import { Pipe, PipeTransform } from "@angular/core";
import { Tools } from "@comunicare/comunicare-helper";

@Pipe({ name: "isNotDefined" })
export class IsNotDefinedPipe implements PipeTransform {
  transform(param1: unknown): boolean {
    return Tools.isNotDefined(param1);
  }
}
